import React from 'react'
import spendingAlertSuccess from "../../../../../assets/images/spending-alert-success.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import logFirebaseEvents from '../../../../LogFirebaseEvents';
import { appTheme } from '../../../../../helpers/utils/Utils';



const SuccessSpendAlertSet = ({ onCanelTranfer, isCancelButton }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleBackToClimb = () => {
        logFirebaseEvents("SpendSense_Alert", "BackTo_Climb_Clicked", "BackTo_Climb_Clicked","", "")
        dispatch({ type: "RESET_ADD_SPEND_ALERTS" })
        navigate('/Toolkit/ToolkitMenu');
    }

    const handleBackToSpendAlerts = () => {
        logFirebaseEvents("SpendSense_Alert", "BackTo_SpendAlerts_Clicked", "BackTo_SpendAlerts_Clicked","", "")
        dispatch({ type: "RESET_ADD_SPEND_ALERTS" })
        navigate('/Toolkit/ManageSpendAlerts');
    }

    return (
        <div className='flex flex-col justify-center items-center w-full'>
            <p className='font-hanken-grotesk lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] 
             md:leading-[28px] text-[var(--heading-in-modal-is-clr)] '>{t("success_spend_alert_notify_msg")}</p>

            <img src={appThemeData.spending_alert_success_icon} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />
            <div className='flex flex-col justify-center items-center w-full'>

                <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                    {/* <button class="font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500]
                     sm:font-bold leading-[24px]  sm:leading-[12px] 
                      md:leading-[16px] bg-[#2965FB] text-white
                      cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={handleBackToClimb}>{t("back_to_climb")}</button>
                    <p className='font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] 
                    sm:font-bold leading-[24px] sm:leading-[12px] 
                   md:leading-[16px] text-secondary-2 capitalize cursor-pointer'
                        onClick={handleBackToSpendAlerts}>{t("back_to_spendsense_alerts")}</p> */}

                    <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={ handleBackToClimb} onKeyDown={(e) => { if (e.key === "Enter") handleBackToClimb() }}>{t("back_to_climb")}</button>
                
                        <button class="font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-[var(--modal-btn-text-color)] cursor-pointer border-2 px-2 py-4 border-[#2965FB] sm:border-none w-full capitalize" onClick={ handleBackToSpendAlerts} onKeyDown={(e) => { if (e.key === "Enter") handleBackToSpendAlerts() }}>{t("back_to_spendsense_alerts")}</button>
                    
                </div>
            </div>

        </div>
    )
}

export default withOidcSecure(SuccessSpendAlertSet)